package com.downdogapp.client.controllers

import com.downdogapp.client.ViewController
import com.downdogapp.client.controllers.CommonKeyboardType.DEFAULT
import com.downdogapp.client.singleton.App
import com.downdogapp.client.views.TextInputView

class TextInputViewController(val title: String,
                              val inputLabel: String,
                              val initialValue: String? = null,
                              val keyboardType: CommonKeyboardType = DEFAULT,
                              val submitCallback: (String) -> Unit) : ViewController() {

  override val view = TextInputView(this)

  fun submitClicked(value: String) {
    onBackClicked()
    submitCallback(value)
  }

  override fun onBackClicked() {
    App.closeKeyboard()
    super.onBackClicked()
  }
}

enum class CommonKeyboardType {
  DEFAULT,
  EMAIL_ADDRESS,
  PASSWORD
}
